module.exports = __webpack_public_path__ + "static/media/bz.73cc7128.webp";